<template lang="pug">
span
  search-select(
    :selected="currentSelected",
    :options="options",
    :placeholder="'请输入搜索内容'",
    @search="search",
    @change="selectChange"
    )
  search-select(
    ref="subSearchSelect",
    :selected="currentSubSelected",
    :options="subOptions",
    :placeholder="'请输入搜索内容'",
    @search="subsearch",
    @change="subselectChange"
    )

</template>
<script>
import SearchSelect from './search-select.vue'
export default {
  props: {
    options: {
      type: Array,
      default() {
        return []
      }
    },
    subOptions: {
      type: Array,
      default() {
        return []
      }
    },
    selected: {
      default: ''
    },
    subSelected: {
      default: ''
    }
  },
  data() {
    return {
      currentSelected: this.selected,
      currentSubSelected: ''
    }
  },
  watch: {
    subOptions() {
      this.$nextTick(() => {
        this.currentSubSelected = this.subSelected
      })
    }
  },
  components: {
      'search-select': SearchSelect,
  },
  methods: {
    search(value) {
      this.$emit('search', value)
    },
    subsearch(value) {
      this.$emit('subsearch', this.currentSelected, value)
    },
    selectChange(selected) {
      if(!selected) return
      this.currentSelected = selected
      if(selected && !_.isEmpty(this.$refs.subSearchSelect.$children)){
        setTimeout(() => {
          this.$refs.subSearchSelect.$children[0].open()
        },300)
      }
      this.$emit('subsearch', selected, '')
    },
    subselectChange(subSelected) {
      if(!subSelected) return
      this.currentSubSelected = subSelected
      this.$emit('change', {currentSelected: this.currentSelected, currentSubSelected: this.currentSubSelected})
    }
  }
}
</script>



// WEBPACK FOOTER //
// casecade.vue?0b2d2857